import { InputHTMLAttributes, forwardRef } from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: React.ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ label, ...props }, ref) => {
	return (
		<label className={styles.container}>
			<input ref={ref} type="checkbox" className={styles.checkbox} {...props} />
			<span className={styles.label}>{label}</span>
		</label>
	);
});

Checkbox.displayName = 'Checkbox';
